var render = function (_h,_vm) {var _c=_vm._c;return _c(_vm.props.tag,{tag:"component",staticClass:"card"},[_c(_vm.props.titleTag,{tag:"component",staticClass:"card__title"},[_vm._v("\n\t\t"+_vm._s(_vm.props.title)+"\n\t")]),_vm._v(" "),_c(_vm.props.bodyTag,{tag:"component",staticClass:"card__body"},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }